import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { ViewerAsset } from '@models/viewer-asset';
import { MarkdownService } from '@shared/markdown.service';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AudioPlayerComponent } from '../../audio-player/audio-player.component';
import { ViewerHelpers } from '../viewer-helpers';
import { ViewerBaseComponent } from '../viewer-shared/viewer-base.component';
import { ViewerService } from '../viewer.service';

@Component({
  selector: 'zbp-viewer-audio',
  templateUrl: './viewer-audio.component.html',
  styleUrls: ['./viewer-audio.component.scss'],
  imports: [AudioPlayerComponent]
})
export class ViewerAudioComponent extends ViewerBaseComponent implements OnChanges, OnInit {
  @Input() viewerAssets: ViewerAsset[] = [];

  assetName: string;
  audioFile: string;
  transcript: string = '';  // New property for text alternative
  showTranscript: boolean = false;  // New toggle for expanded visibility

  constructor(
    private markdown: MarkdownService,
    private viewerService: ViewerService) {
    super();
  }

  ngOnInit(): void {
    this.setupAudio();
  }

  ngOnChanges(): void {
    this.setupAudio();
  }

  setupAudio() {
    this.assetName = ViewerHelpers.removeMarkupFromText(this.asset.name);
    // Use 'transcript' property from ViewerAsset model (no API call needed); fallback to name if empty
    this.transcript = this.markdown.render(this.asset.transcript || this.assetName || '');

    this.viewerService.getMediaBlobUri(
      this.viewerService.getAssetFilenameUrl(this.asset, 'media', this.asset.language))
      .pipe(
        catchError((err) => {
          console.error(err);
          return of(null);
        })
      )
      .subscribe((uri) => {
        if (uri) {
          this.audioFile = uri;
          this.setLoaded();
        } else {
          this.withError.emit('Unable to load this resource');
        }
      });
  }

  toggleTranscript(): void {
    this.showTranscript = !this.showTranscript;
  }

  setLoaded(): void {
    setTimeout(() => {
      this.loaded.emit();
    }, 0);
  }
}
